// Default letter templates with placeholders

export const LETTER_TYPES = [
  { value: "offer", label: "Offer Letter" },
  { value: "appointment", label: "Appointment Letter" },
  { value: "interview-call", label: "Interview Call" },
  { value: "rejection", label: "Rejection" },
  { value: "welcome", label: "Welcome Letter" },
  { value: "nda", label: "NDA" },
  { value: "internship-offer", label: "Internship Offer" },
  { value: "appraisal", label: "Appraisal" },
  { value: "promotion", label: "Promotion" },
  { value: "salary-increment", label: "Salary Increment" },
  { value: "appreciation", label: "Appreciation" },
  { value: "annual-bonus", label: "Annual Bonus" },
  { value: "confirmation", label: "Confirmation" },
  { value: "probation-extension", label: "Probation Extension" },
  { value: "transfer", label: "Transfer" },
  { value: "resignation-acceptance", label: "Resignation Acceptance" },
  { value: "relieving", label: "Relieving Letter" },
  { value: "warning", label: "Warning" },
  { value: "show-cause", label: "Show Cause" },
  { value: "suspension", label: "Suspension" },
  { value: "demotion", label: "Demotion" },
  { value: "termination", label: "Termination" },
  { value: "experience", label: "Experience Certificate" },
  { value: "verification", label: "Verification" },
  { value: "recommendation", label: "Recommendation" },
  { value: "internship-completion", label: "Internship Completion" },
  { value: "authorization", label: "Authorization" },
  { value: "approval", label: "Approval" },
  { value: "denial", label: "Denial" },
  { value: "internal-announcement", label: "Internal Announcement" },
];

export const DEFAULT_TEMPLATES = {
  offer: {
    subject: "Job Offer - {{designation}} at {{companyName}}",
    content: `Dear {{employeeName}},

We are pleased to offer you the position of {{designation}} at {{companyName}}, reporting to {{manager}}.

Your employment will commence on {{joinDate}}. Your starting salary will be {{salary}} per annum, payable in accordance with the company's standard payroll practices.

This offer is contingent upon:
- Successful completion of background verification
- Submission of all required documents
- Acceptance of our terms and conditions of employment

Please confirm your acceptance of this offer by {{responseDate}}.

We look forward to welcoming you to our team.

Sincerely,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  appointment: {
    subject: "Appointment Letter - {{designation}}",
    content: `Dear {{employeeName}},

Further to your acceptance of our offer letter dated {{offerDate}}, we are pleased to confirm your appointment as {{designation}} in the {{department}} department, effective {{joinDate}}.

Terms of Employment:
- Position: {{designation}}
- Department: {{department}}
- Reporting to: {{manager}}
- Salary: {{salary}} per annum
- Probation Period: {{probationPeriod}} months

You will be expected to comply with all company policies and procedures as outlined in the employee handbook.

Please sign and return a copy of this letter as acknowledgment of your acceptance of these terms.

Welcome aboard!

Sincerely,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  promotion: {
    subject: "Congratulations on Your Promotion!",
    content: `Dear {{employeeName}},

We are delighted to inform you that you have been promoted to the position of {{newDesignation}}, effective {{effectiveDate}}.

This promotion is a testament to your hard work, dedication, and exceptional performance. Your new responsibilities will include {{responsibilities}}.

Details of your promotion:
- New Position: {{newDesignation}}
- Department: {{department}}
- New Salary: {{newSalary}} per annum
- Reporting to: {{manager}}

Congratulations on this well-deserved promotion. We look forward to your continued success.

Best regards,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  appreciation: {
    subject: "Letter of Appreciation",
    content: `Dear {{employeeName}},

I want to take a moment to express my sincere appreciation for your outstanding work on {{project}}.

Your {{qualities}} have made a significant impact on our team's success. Your dedication and professionalism are truly commendable.

Thank you for your continued commitment to excellence.

Warm regards,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  confirmation: {
    subject: "Confirmation of Employment",
    content: `Dear {{employeeName}},

We are pleased to inform you that you have successfully completed your probation period. Your employment with {{companyName}} is now confirmed, effective {{confirmationDate}}.

We appreciate your contributions during your probation period and look forward to your continued success with our organization.

Your confirmed employment details:
- Position: {{designation}}
- Department: {{department}}
- Salary: {{salary}} per annum

Congratulations on your confirmation!

Best regards,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  relieving: {
    subject: "Relieving Letter",
    content: `To Whom It May Concern,

This is to certify that {{employeeName}} was employed with {{companyName}} from {{joinDate}} to {{lastWorkingDay}}.

During their tenure, {{employeeName}} worked as {{designation}} in the {{department}} department.

{{employeeName}} has cleared all dues and returned all company property. We have no objections to their future employment.

We wish {{employeeName}} all the best in their future endeavors.

Sincerely,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  experience: {
    subject: "Experience Certificate",
    content: `To Whom It May Concern,

This is to certify that {{employeeName}} worked with {{companyName}} from {{joinDate}} to {{lastWorkingDay}} as {{designation}} in the {{department}} department.

During their employment, {{employeeName}} demonstrated professionalism, dedication, and strong work ethic. Their performance was consistently satisfactory.

We wish them success in all future endeavors.

Sincerely,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}
Date: {{issueDate}}`,
  },

  warning: {
    subject: "Warning Letter",
    content: `Dear {{employeeName}},

This letter serves as a formal warning regarding {{issue}}.

On {{incidentDate}}, it was brought to our attention that {{description}}.

This behavior/action is in violation of our company policy and is unacceptable. We expect immediate improvement in this area.

Please consider this a formal warning. Any further incidents may result in additional disciplinary action, up to and including termination of employment.

We trust you will take corrective action immediately.

Sincerely,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  "internship-offer": {
    subject: "Internship Offer - {{companyName}}",
    content: `Dear {{employeeName}},

We are pleased to offer you an internship position in our {{department}} department at {{companyName}}.

Internship Details:
- Position: {{designation}}
- Duration: {{duration}}
- Start Date: {{startDate}}
- Stipend: {{stipend}} per month
- Supervisor: {{manager}}

This internship will provide you with valuable hands-on experience and exposure to {{description}}.

Please confirm your acceptance by {{responseDate}}.

We look forward to having you join our team.

Best regards,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },

  "salary-increment": {
    subject: "Salary Increment Notification",
    content: `Dear {{employeeName}},

We are pleased to inform you that your salary has been revised, effective {{effectiveDate}}.

Your new compensation details are as follows:
- Current Salary: {{currentSalary}}
- New Salary: {{newSalary}}
- Increment: {{incrementPercentage}}%

This increment reflects your valuable contributions and strong performance over the past year.

Congratulations!

Best regards,

{{signatoryName}}
{{signatoryTitle}}
{{companyName}}`,
  },
};

export function getPlaceholders() {
  return [
    "{{employeeName}}",
    "{{designation}}",
    "{{newDesignation}}",
    "{{department}}",
    "{{companyName}}",
    "{{manager}}",
    "{{salary}}",
    "{{monthlySalary}}",
    "{{newSalary}}",
    "{{currentSalary}}",
    "{{joinDate}}",
    "{{effectiveDate}}",
    "{{lastWorkingDay}}",
    "{{responseDate}}",
    "{{signatoryName}}",
    "{{signatoryTitle}}",
    "{{probationPeriod}}",
    "{{confirmationDate}}",
    "{{issueDate}}",
    "{{incrementPercentage}}",
    "{{stipend}}",
    "{{duration}}",
    "{{project}}",
    "{{qualities}}",
    "{{responsibilities}}",
  ];
}

export function replacePlaceholders(template, data) {
  let result = template;
  Object.keys(data).forEach((key) => {
    const placeholder = `{{${key}}}`;
    result = result.replace(new RegExp(placeholder, "g"), data[key] || "");
  });
  return result;
}
